import { SWReactIcons } from '@similarweb/icons';
import { colorsPalettes } from '@similarweb/styles';

import { NewTag } from '../../../../components/NewTag';

import {
  StyledPreferencesHeader,
  StyledPreferencesTitle,
  StyledPreferencesSubtitle,
  StyledClosePreferencesButton,
} from './styles';

type PreferencesHeaderProps = {
  title: string;
  subtitle: string;
  onReturn: () => void;
  isNew?: boolean;
};

export const PreferencesHeader = ({ title, subtitle, onReturn, isNew }: PreferencesHeaderProps) => {
  return (
    <>
      <StyledPreferencesHeader>
        <StyledClosePreferencesButton data-automation="Return" onClick={onReturn}>
          <SWReactIcons iconName="arrow-left" size="xs" iconColor={colorsPalettes.carbon[500]} />
        </StyledClosePreferencesButton>
        <StyledPreferencesTitle>
          {title}
          {isNew ? <NewTag /> : null}
        </StyledPreferencesTitle>
      </StyledPreferencesHeader>
      <StyledPreferencesSubtitle>{subtitle}</StyledPreferencesSubtitle>
    </>
  );
};
